import { render, staticRenderFns } from "./HostsPage.vue?vue&type=template&id=18d5c7c6&"
import script from "./HostsPage.vue?vue&type=script&lang=js&"
export * from "./HostsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports